export const hamburgerMenu = () => {
    const hamburgerBtn = document.querySelector('.js-hamburger');
    const mobileNav = document.querySelector('.js-mobile-nav');
    const body = document.body;
    
    if (!hamburgerBtn || !mobileNav) return;
    
    let scrollPosition = 0; // スクロール位置を保存
    
    // メニューを閉じる共通関数
    const closeMenu = () => {
        hamburgerBtn.classList.remove('is-active');
        mobileNav.classList.remove('is-active');
        body.classList.remove('menu-open');
        
        // スクロール位置を復元
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, scrollPosition);
    };
    
    // メニューを開く共通関数
    const openMenu = () => {
        // 現在のスクロール位置を保存
        scrollPosition = window.pageYOffset;
        
        hamburgerBtn.classList.add('is-active');
        mobileNav.classList.add('is-active');
        body.classList.add('menu-open');
        
        // スクロール位置を固定
        body.style.position = 'fixed';
        body.style.top = `-${scrollPosition}px`;
        body.style.width = '100%';
    };
    
    // ハンバーガーボタンと閉じるボタンのクリック処理
    document.addEventListener('click', (e) => {
        if (e.target.closest('.js-hamburger')) {
            const isActive = mobileNav.classList.contains('is-active');
            
            if (isActive) {
                closeMenu();
            } else {
                openMenu();
            }
        }
    });
    
    // モバイルナビ内のリンククリック時にメニューを閉じる
    const mobileNavLinks = mobileNav.querySelectorAll('a');
    mobileNavLinks.forEach(link => {
        link.addEventListener('click', () => {
            closeMenu();
        });
    });
    
    // ウィンドウリサイズ時の処理（768px以上でメニューを閉じる）
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 768 && mobileNav.classList.contains('is-active')) {
            closeMenu();
        }
    });
    
    // ESCキーでメニューを閉じる
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileNav.classList.contains('is-active')) {
            closeMenu();
        }
    });
}; 